import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
    Aangifte, BokkzAlgDataService,
    Box3InkomenUitSparenEnBeleggen, IncomeTaxEntity,
    Lening, LeningAanwending
} from "@snelstart-ventures/fiscaal/domain-logic";
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {
    optionsLandcodesMetNLD,
} from "../../gedeelde-componenten/gedeelde-componenten.component";
import {filter, Subscription} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiIconModule } from '@snelstart/ui-icon';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-box3-leningen',
  templateUrl: './box3-leningen.component.html',
  styleUrls: ['./box3-leningen.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        SharedUiAlertModule,
        SharedUiDetailsModule,
        CommonModule,
        SharedUiDialogModule,
        SharedUiIconModule
    ]
})
export class Box3LeningenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public clientId!: string;
    public dialogVisible = false;
    public index = 0;

    public incomeTaxEntity = {} as IncomeTaxEntity;

    private focusedElementId: string | null = null;
    public jaar = 2024;

    public showAlertGeenBox3Woning = false;
    public hasAanwendingIsWoning = false;

    private isSavingInit = false;

    heeftOWR: boolean[] = [];

    public soortAanwending: SelectFormControlItem<string>[] = [
        {value: LeningAanwending.OVERIG, label: "Overig schulden"},
        {value: LeningAanwending.WONING_NEDERLAND, label: "Box 3-woning Nederland"},
        {value: LeningAanwending.WONING_BUITENLAND, label: "Box 3-woning buitenland"}
    ];

    public optionsLandcodes: SelectFormControlItem<string>[] = optionsLandcodesMetNLD;

    public leningen = {} as FormGroup
    public onroerendeZaken: SelectFormControlItem<string>[] = [];
    public labelJaar = '';
    public labelJaarEind = '';

    showDialog(index: number) {
        this.index = index;
        this.dialogVisible = true;
    }

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.leningen = this.fb.group({
            box3Leningen:
                this.fb.array<Box3InkomenUitSparenEnBeleggen>([])
        })
    }

    get box3Leningen(): FormArray {
        return this.leningen.get('box3Leningen') as FormArray;
    }

    addRijLeningen(): void {
        this.box3Leningen.push(this.createLeningenFormGroup()
        )
    }

    verwijderRijLeningen(index: number): void {
        const teVerwijderenLening = this.box3Leningen.at(index).getRawValue();

        // Onthoud dat deze lening verwijderd is
        if (teVerwijderenLening.omschrijving) {
            this.dataService.box3LeningenVerwijderd.add(teVerwijderenLening.omschrijving);
        }

        this.box3Leningen.removeAt(index);
        this.leningen.updateValueAndValidity();
        this.leningen.markAsDirty();
        this.saveForm();
    }


    createLeningenFormGroup(lening?: Lening): FormGroup {
        return this.fb.group({
            omschrijving: lening ? lening.omschrijving : undefined,
            bedrag: lening ? lening.bedrag : undefined,
            rekeningNummer: lening ? lening.rekeningNummer : undefined,
            landCode: lening ? lening.landCode : undefined,
            wozNummerWaarLeningBijHoort: lening ? lening.wozNummerWaarLeningBijHoort : undefined,
            percentageBox1: lening?.percentageBox1 ?? 0,
            hoofdsom0101: lening ? lening.bedrag : undefined,
            hoofdsom3112: lening ? lening.hoofdsom3112 : undefined,
            geldVerstrekker: lening ? lening.geldVerstrekker : 'BANK',
            aanwending: lening ? lening.aanwending : undefined,
            bijzondereWaardevermindering: lening ? lening.bijzondereWaardevermindering : undefined,
            rente: lening ? lening.rente : undefined,
        } as Lening, { validators: this.box3WoningValidator() });
    }

    public verwijderLetters(input: string): string {
        return input.replace(/\D/g, '');
    }


    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.onroerendeZaken = [];

                if (this.incomeTaxEntity.aangifte &&
                    this.incomeTaxEntity.aangifte.box3 &&
                    this.incomeTaxEntity.aangifte.box3.overigeOnroerendeZaken &&
                    this.incomeTaxEntity.aangifte.box3.overigeOnroerendeZaken.length > 0) {

                    for (let i = 0; i < this.incomeTaxEntity.aangifte.box3.overigeOnroerendeZaken.length; i++) {
                        if (this.incomeTaxEntity.aangifte.box3.overigeOnroerendeZaken[i]) {
                            const currentData = this.incomeTaxEntity.aangifte.box3.overigeOnroerendeZaken[i].adres;

                            if (currentData.postcode) {
                                let code = currentData.postcode;
                                code = this.verwijderLetters(code);
                                const adres = this.incomeTaxEntity.aangifte.box3.overigeOnroerendeZaken[i].adres;
                                const postcode = adres?.postcode ?? '1111';
                                const huisnr = adres?.huisNummer ?? '2222';
                                const woz = this.incomeTaxEntity.aangifte.box3.overigeOnroerendeZaken[i].woz ?? '3333';
                                let woznummerValue = [i, postcode, huisnr, woz].map(String).join('');
                                woznummerValue = woznummerValue.replace(/\D/g, '').slice(0, 12).padStart(12, '0');
                                const selectFormItem: SelectFormControlItem<string> = {
                                    value: woznummerValue,
                                    label: currentData.postcode + ' - ' + currentData.huisNummer +
                                        (currentData.huisNummerToevoeging ? ' - ' + currentData.huisNummerToevoeging : ''),
                                };
                                this.onroerendeZaken.push(selectFormItem);
                            }
                        }
                    }
                }

                this.aangifte = aangifte;

                if (this.isSavingInit) {
                    this.isSavingInit = false;
                    return;
                }

                const key = `${incomeTaxEntity.sstRelationId}-${aangifte.aangifteJaar}`;
                const heeftBox1LeningenMetPercentage = aangifte?.box1
                    ?.belastbareInkomstenUitEigenWoning?.leningen
                    ?.some(l => l.percentageBox1 !== undefined &&
                        l.percentageBox1 !== null &&
                        l.percentageBox1 !== 100) ?? false;

                const heeftBox3Leningen = (aangifte?.box3?.leningen?.length ?? 0) > 0;

// Controleer of alle box1 leningen bewust verwijderd zijn
                const alleBox1LeningenVerwijderd = aangifte?.box1
                    ?.belastbareInkomstenUitEigenWoning?.leningen
                    ?.filter(l => l.percentageBox1 !== undefined &&
                        l.percentageBox1 !== null &&
                        l.percentageBox1 !== 100)
                    ?.every((l, index) => {
                        const omschrijving = `Box 3-deel  ${l.omschrijving ?? 'Bank'}-${index}`;
                        return this.dataService.box3LeningenVerwijderd.has(omschrijving);
                    }) ?? false;

                if (this.dataService.box3LeningenGeinitialiseerdVoor.has(key) &&
                    heeftBox1LeningenMetPercentage &&
                    !heeftBox3Leningen &&
                    !alleBox1LeningenVerwijderd) {
                    this.dataService.box3LeningenGeinitialiseerdVoor.delete(key);
                }

                if (!this.dataService.box3LeningenGeinitialiseerdVoor.has(key)) {
                    this.vulBox3LeningenVanuitBox1(aangifte);
                    this.dataService.box3LeningenGeinitialiseerdVoor.add(key);
                    this.incomeTaxEntity.aangifte = aangifte;
                    this.dataService.postIncomeTaxEntity(
                        incomeTaxEntity.sstRelationId!,
                        false,
                        this.incomeTaxEntity
                    );
                    this.updateForm(aangifte);
                    this.updateHeeftOWR();
                    this.labelJaar = `Saldo 1-1-${aangifte.aangifteJaar}`;
                    this.labelJaarEind = aangifte.aangifteJaar
                        ? `Saldo 31-12-${aangifte.aangifteJaar}`
                        : 'Saldo 31-12';
                    if (incomeTaxEntity.year !== undefined) {
                        this.jaar = incomeTaxEntity.year;
                    }
                    return;
                }

                this.updateForm(aangifte);
                this.updateHeeftOWR();
                this.labelJaar = `Saldo 1-1-${this.incomeTaxEntity.aangifte?.aangifteJaar}`;
                this.labelJaarEind = this.aangifte.aangifteJaar
                    ? `Saldo 31-12-${this.aangifte.aangifteJaar}`
                    : 'Saldo 31-12';
                if (incomeTaxEntity.year !== undefined) {
                    this.jaar = incomeTaxEntity.year;
                }
            }
        });

        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        });

        this.routerSubscription = this.router.events
            .pipe(
                filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.leningen.dirty
    }

    private updateForm(aangifte?: Aangifte): void {
        const bronAangifte = aangifte ?? this.incomeTaxEntity.aangifte;
        const leningenLijst = bronAangifte?.box3?.leningen || [];

        const formArray = this.leningen.get('box3Leningen') as FormArray;
        const focusedControl = this.focusedElementId
            ? document.getElementById(this.focusedElementId) as HTMLElement
            : null;

        while (formArray.length > leningenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < leningenLijst.length; i++) {
            const lening = leningenLijst[i];
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(lening);
            } else {
                formArray.push(this.createLeningenFormGroup(lening));
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        this.box3Leningen.controls.forEach((group: AbstractControl) => {
            if (group instanceof FormGroup) {
                Object.keys(group.controls).forEach(key => {
                    group.get(key)?.markAsTouched();
                });
                group.markAsTouched();
            }
        });

        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity.aangifte,
                box3: {
                    ...this.incomeTaxEntity.aangifte?.box3,
                    leningen: this.leningen.getRawValue().box3Leningen
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            this.checkBox3Woning();
        }, 0);
        this.updateHeeftOWR();
    }

    checkBox3Woning() {
        const hasNoBox3Woning = (this.incomeTaxEntity !== undefined &&
                this.incomeTaxEntity.aangifte !== undefined &&
                this.incomeTaxEntity.aangifte?.box3 !== undefined) &&
            (this.incomeTaxEntity.aangifte?.box3?.overigeOnroerendeZaken === undefined || (this.incomeTaxEntity.aangifte?.box3?.overigeOnroerendeZaken.length < 1));

        const leningenLijst = this.incomeTaxEntity?.aangifte?.box3?.leningen || [];

        this.hasAanwendingIsWoning = leningenLijst.some(
            (lening) => lening.aanwending === LeningAanwending.WONING_NEDERLAND || lening.aanwending === LeningAanwending.WONING_BUITENLAND
        );

        this.showAlertGeenBox3Woning = hasNoBox3Woning && this.hasAanwendingIsWoning;
    }

    protected readonly LeningAanwending = LeningAanwending;

    box3WoningValidator(): ValidatorFn {
        return (group: AbstractControl): ValidationErrors | null => {
            const aanwending = group.get('aanwending')?.value;
            const wozNummer = group.get('wozNummerWaarLeningBijHoort')?.value;
            const landCode = group.get('landCode')?.value;

            // Check of aanwending een box 3-woning is (NL of buitenland)
            const isBox3Woning = aanwending === LeningAanwending.WONING_NEDERLAND ||
                aanwending === LeningAanwending.WONING_BUITENLAND;

            let hasErrors = false;

            // Check wozNummer
            if (isBox3Woning && (wozNummer === null || wozNummer === undefined || wozNummer === '')) {
                group.get('wozNummerWaarLeningBijHoort')?.setErrors({ required: true });
                hasErrors = true;
            } else {
                const wozControl = group.get('wozNummerWaarLeningBijHoort');
                if (wozControl?.hasError('required') && !isBox3Woning) {
                    wozControl.setErrors(null);
                }
            }

            // Check landCode
            if (isBox3Woning && (landCode === null || landCode === undefined || landCode === '')) {
                group.get('landCode')?.setErrors({ required: true });
                hasErrors = true;
            } else {
                const landControl = group.get('landCode');
                if (landControl?.hasError('required') && !isBox3Woning) {
                    landControl.setErrors(null);
                }
            }

            // Return error alleen als er daadwerkelijk errors zijn
            return hasErrors ? { box3WoningRequired: true } : null;
        };
    }

    getOWRDialogTitel(i: number): string {
        const omschrijving = this.box3Leningen.controls[i]?.get('omschrijving')?.value;
        const rekeningnummer =this.box3Leningen.controls[i]?.get('rekeningNummer')?.value;

        if (!omschrijving || !rekeningnummer) {
            return 'Werkelijk rendement schuld';
        }

        return `Werkelijk rendement: ${omschrijving} - ${rekeningnummer}`;
    }

    updateHeeftOWR(): void {
        this.heeftOWR = this.box3Leningen.controls.map((item) => {
            const velden = ['bijzondereWaardevermindering', 'hoofdsom3112', 'betaaldeRente'];
            return velden.some(veld => item?.get(veld)?.value);
        });
    }

    getBerekendeWerkelijkRendement(i: number): number | null {
        const control = this.box3Leningen.at(i);
        const bijzondereWaardevermindering = Number(control?.get('bijzondereWaardevermindering')?.value) || 0;
        const rente = Number(control?.get('rente')?.value) || 0;

        // Return null als beide waarden leeg zijn
        if (!control?.get('bijzondereWaardevermindering')?.value && !control?.get('rente')?.value) {
            return null;
        }

        return bijzondereWaardevermindering + rente;
    }

    private vulBox3LeningenVanuitBox1(aangifte: Aangifte): void {

        const eigenWoningSchulden = aangifte?.box1
            ?.belastbareInkomstenUitEigenWoning?.leningen;


        if (!eigenWoningSchulden || !Array.isArray(eigenWoningSchulden)) {
            return;
        }

        aangifte.box3 ??= { leningen: [] };
        aangifte.box3.leningen ??= [];

        eigenWoningSchulden.forEach((eigenWoningSchuld, index) => {

            if (eigenWoningSchuld.percentageBox1 === undefined ||
                eigenWoningSchuld.percentageBox1 === null ||
                eigenWoningSchuld.percentageBox1 === 100) {
                return;
            }

            const percentage = (100 - eigenWoningSchuld.percentageBox1) / 100;
            const ews = eigenWoningSchuld.hoofdsom0101 || 0;

            const baseOmschrijving = eigenWoningSchuld.omschrijving ?? 'Bank';
            const omschrijving = `Box 3-deel  ${baseOmschrijving}-${index}`;

            const bestaatAl = aangifte.box3!.leningen!.some(
                l => l.omschrijving === omschrijving
            );

            if (bestaatAl || this.dataService.box3LeningenVerwijderd.has(omschrijving)) return;

            const nieuweSchuld: Lening = {
                ...eigenWoningSchuld,
                omschrijving,
                hoofdsom0101: Math.round(ews * percentage),
                bedrag: Math.round(ews * percentage),
                hoofdsom3112: eigenWoningSchuld.hoofdsom3112 != null
                    ? Math.round(eigenWoningSchuld.hoofdsom3112 * percentage)
                    : undefined,
                rente: eigenWoningSchuld.rente != null
                    ? Math.round(eigenWoningSchuld.rente * percentage)
                    : undefined,
                percentageBox1: 0,
                aanwending: LeningAanwending.OVERIG,
            };

            if (nieuweSchuld.bedrag && nieuweSchuld.bedrag > 0) {
                aangifte.box3!.leningen!.push(nieuweSchuld);

            } else {
            }
        });

    }



}
